<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <merus-data-table
      :headers="headers"
      :items="recebidos"
      :loading="loading"
      :server-items-length="total"
      :items-per-page="options.itemsPerPage"
      mostrar-inativos
      item-key="id_envio"
      @update:options="onTableOptions"
      @click:row="abrir"
    >
        <template v-slot:toolbar>
          <cadastro-toolbar
            :title="$t('receivedTemplate.title')"
            :token="token"
            :items="recebidos"
            :csv-title="$t('receivedTemplate.title')"
            :csv-headers="headers"
            :pdf-title="$t('receivedTemplate.title')"
            :pdf-headers="headers"
            :pdf-filename="$t('receivedTemplate.title')"
            hide-search
          />
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small :color="corStatus(item.status)" class="white--text">
            {{ $t('receivedTemplate.status.' + item.status) }}
          </v-chip>
        </template>
        <template v-slot:item.dt_envio="{ item }">{{ formataData(item.dt_envio) }}</template>
        <template v-slot:item.dt_preenchimento="{ item }">{{ formataData(item.dt_preenchimento) }}</template>
        <template v-slot:item.actions="{ item }">
          <v-icon small :color="item.status === 'PREENCHIDO' ? 'primary' : 'green'" @click.stop="abrir(item)">
            {{ item.status === 'PREENCHIDO' ? 'mdi-eye' : 'mdi-pencil' }}
          </v-icon>
        </template>
    </merus-data-table>

    <v-dialog v-model="dialog" max-width="1000" scrollable>
      <v-card v-if="envio">
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">{{ envio.nome_template }}</span>
        </v-card-title>
        <v-card-subtitle v-if="envio.descricao">{{ envio.descricao }}</v-card-subtitle>
        <v-card-text>
          <v-alert v-if="!editavel" type="info" dense text>{{ $t('receivedTemplate.readOnly') }}</v-alert>
          <v-alert v-else type="info" dense text>{{ $t('receivedTemplate.fillHint') }}</v-alert>

          <v-card class="pa-4 mb-4" outlined>
            <div class="text-h6 mb-3">{{ $t('contract.sections.generalData') }}</div>
            <v-row dense>
              <v-col v-for="campo in camposGerais" :key="campo.chave" cols="12" :sm="campo.largo ? 12 : 6" :md="campo.largo ? 6 : 3">
                <v-text-field :value="campo.valor" :label="campo.label" disabled dense></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card v-for="tipo in tipos" :key="'tv-' + tipo.id_tipo_veiculo" outlined class="pa-4 mb-4">
            <div class="text-h6 mb-3">{{ rotuloTipo(tipo.id_tipo_veiculo) }}</div>

            <template v-if="envio.config_snapshot.modelo_mao_obra === 'FAIXAS'">
              <div class="text-subtitle-2 mb-2">{{ $t('receivedTemplate.laborRanges') }}</div>
              <v-row dense>
                <v-col v-for="col in colunasFaixas" :key="col" cols="12" sm="6" md="4">
                  <v-text-field
                    v-model.number="valores[tipo.id_tipo_veiculo].faixas_mao_obra[col]"
                    :label="$t('receivedTemplate.range.' + col)"
                    type="number"
                    min="0"
                    step="any"
                    prefix="$"
                    hide-spin-buttons
                    :disabled="!editavel"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <div v-if="tipo.linhas.length" class="text-subtitle-2 mb-2">{{ $t('receivedTemplate.rows') }}</div>
            <v-row dense v-for="linha in tipo.linhas" :key="linha.cod_tarifa">
              <v-col cols="12" sm="8">
                <v-text-field :value="rotuloTarifa(linha.cod_tarifa)" :label="$t('receivedTemplate.tariff')" disabled dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.number="valores[tipo.id_tipo_veiculo].linhas[linha.cod_tarifa]"
                  :label="$t('receivedTemplate.value')"
                  type="number"
                  min="0"
                  step="any"
                  prefix="$"
                  hide-spin-buttons
                  :disabled="!editavel"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" class="white--text" @click="fechar">{{ $t('button.close') }}</v-btn>
          <template v-if="editavel">
            <v-btn color="primary darken-1" class="white--text" :loading="salvando" @click="salvar(false)">
              {{ $t('receivedTemplate.saveDraft') }}
            </v-btn>
            <v-btn color="green darken-1" class="white--text" :loading="salvando" @click="salvar(true)">
              {{ $t('receivedTemplate.finish') }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

// Mesmas colunas das faixas de mão de obra do contrato (api/utils/subsidioValorLinhaContrato.js).
const COLUNAS_FAIXAS = [
  'valor_mo_1mot_1t_seg_sab',
  'valor_mo_1_5mot_1t_30d',
  'valor_mo_2mot_2t_seg_sab',
  'valor_mo_2_5mot_2t_30d',
  'valor_mo_3mot_3t_30d',
];

/**
 * Templates de contrato enviados ao usuário logado. O cliente vê só o que foi
 * enviado a ele e edita apenas valores (linhas e faixas de mão de obra); o
 * restante do template é somente leitura. O resultado fica como rascunho no
 * envio, para revisão interna.
 */
export default {
  name: 'CRUDTemplatesRecebidos',
  components: { MerusDataTable, CadastroToolbar },
  data: () => ({
    token: sessionStorage.getItem('api'),
    recebidos: [],
    total: 0,
    loading: false,
    carregou: false,
    options: { page: 1, itemsPerPage: 10 },
    dialog: false,
    envio: null,
    valores: {},
    salvando: false,
    colunasFaixas: COLUNAS_FAIXAS,
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('receivedTemplate.name'), value: 'nome_template', sortable: false },
        { text: this.$t('receivedTemplate.statusLabel'), value: 'status', sortable: false },
        { text: this.$t('receivedTemplate.sentAt'), value: 'dt_envio', sortable: false },
        { text: this.$t('receivedTemplate.filledAt'), value: 'dt_preenchimento', sortable: false },
      ];
    },
    // Todos os tipos escolhidos no template, mesmo os sem linhas de valor.
    tipos() {
      if (!this.envio) return [];
      const doTemplate = this.envio.config_snapshot.tipos_veiculo || [];
      return (this.envio.ids_tipos_veiculo || []).map(
        (id) => doTemplate.find((t) => Number(t.id_tipo_veiculo) === id) || { id_tipo_veiculo: id, faixas_mao_obra: {}, linhas: [] },
      );
    },
    camposGerais() {
      if (!this.envio) return [];
      const c = this.envio.config_snapshot;
      const r = this.envio.rotulos || {};
      const sn = (v) => (Number(v) === 1 ? this.$t('receivedTemplate.yes') : this.$t('receivedTemplate.no'));
      const ciclos = {
        MENSAL: this.$t('contract.paymentCycle.monthly'),
        QUINZENAL: this.$t('contract.paymentCycle.biweekly'),
        DIAS: this.$t('contract.paymentCycle.customDays'),
      };
      return [
        { chave: 'cod', label: this.$t('contract.contractCode'), valor: c.cod_contrato },
        { chave: 'cli', label: this.$t('contract.client'), valor: r.cliente },
        { chave: 'emp', label: this.$t('contract.company'), valor: r.empresa },
        { chave: 'uni', label: this.$t('contract.unit'), valor: (r.unidades || []).join(', ') },
        { chave: 'desc', label: this.$t('contract.description'), valor: c.descricao, largo: true },
        { chave: 'obs', label: this.$t('contractTemplate.observations'), valor: c.observacoes, largo: true },
        { chave: 'ini', label: this.$t('contract.startValidity'), valor: c.dt_inicio },
        { chave: 'fim', label: this.$t('contract.endValidity'), valor: c.dt_fim },
        { chave: 'mod', label: this.$t('contractV2.laborModel'), valor: c.modelo_mao_obra === 'FAIXAS' ? this.$t('contractV2.laborModelRanges') : this.$t('contractV2.laborModelDefault') },
        { chave: 'cic', label: this.$t('contract.paymentCycle.type'), valor: ciclos[c.tipo_ciclo_pagamento] },
        { chave: 'dia', label: this.$t('contract.paymentCycle.closingDay'), valor: c.dia_ciclo_pagamento },
        { chave: 'dias', label: this.$t('contract.paymentCycle.dayCount'), valor: c.dias_ciclo_pagamento },
        { chave: 'ref', label: this.$t('contract.paymentCycle.anchorDate'), valor: c.dt_referencia_ciclo },
        { chave: 'pra', label: this.$t('contract.conditions.paymentTermDays'), valor: c.prazo_pagamento_dias },
        { chave: 'ida', label: this.$t('contract.conditions.fleetAverageAge'), valor: c.idade_media_frota_anos },
        { chave: 'dis', label: this.$t('contract.conditions.maxTripDistance'), valor: c.distancia_max_viagem_m },
        { chave: 'tem', label: this.$t('contract.conditions.tripTime'), valor: c.tempo_viagem_min },
        { chave: 'pre', label: this.$t('contract.conditions.representativeValue'), valor: c.valor_preposto },
        { chave: 'tim', label: this.$t('contract.conditions.serviceTeam'), valor: sn(c.time_atendimento) },
        { chave: 'int', label: this.$t('contract.conditions.intercityLines'), valor: sn(c.linhas_intermunicipais) },
        { chave: 'ind', label: this.$t('contract.conditions.adjustmentIndicators'), valor: (r.indicadores || []).join(', ') },
      ].filter((campo) => campo.valor != null && campo.valor !== '');
    },
    editavel() {
      return !!this.envio && ['ENVIADO', 'EM_PREENCHIMENTO'].includes(this.envio.status);
    },
  },
  methods: {
    // Paginação no servidor: a tabela avisa a página e o tamanho escolhidos.
    onTableOptions(opts) {
      if (!opts) return;
      const itemsPerPage = opts.itemsPerPage;
      if (opts.page === this.options.page && itemsPerPage === this.options.itemsPerPage && this.carregou) return;
      this.options = { page: opts.page || 1, itemsPerPage };
      this.carrega();
    },
    formataData(valor) {
      return valor ? new Date(valor).toLocaleString() : '';
    },
    corStatus(status) {
      return { ENVIADO: 'orange', EM_PREENCHIMENTO: 'blue', PREENCHIDO: 'green' }[status] || 'grey';
    },
    rotuloTipo(id) {
      return ((this.envio.rotulos || {}).tipos_veiculo || {})[id] || `#${id}`;
    },
    rotuloTarifa(cod) {
      return ((this.envio.rotulos || {}).tarifas || {})[cod] || cod;
    },
    async carrega() {
      this.loading = true;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetRecebidostemplatecontrato, {
          // "Todos" (-1) vira o máximo aceito pelo servidor.
          query: {
            page: this.options.page,
            pageSize: this.options.itemsPerPage > 0 ? Math.min(this.options.itemsPerPage, 100) : 100,
          },
          silent: true,
        });
        this.recebidos = response.data.items || [];
        this.total = response.data.total || 0;
        this.carregou = true;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.loading = false;
      }
    },
    async abrir(item) {
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetEnviorecebidotemplatecontrato, {
          params: { id: item.id_envio },
          silent: true,
        });
        const envio = response.data;
        // Parte do que o cliente já salvou, senão do valor do template.
        const salvos = (envio.valores_preenchidos && envio.valores_preenchidos.tipos_veiculo) || [];
        const valores = {};
        (envio.ids_tipos_veiculo || []).forEach((id) => {
          const tipo = (envio.config_snapshot.tipos_veiculo || []).find((t) => Number(t.id_tipo_veiculo) === id)
            || { id_tipo_veiculo: id, faixas_mao_obra: {}, linhas: [] };
          const salvo = salvos.find((s) => Number(s.id_tipo_veiculo) === Number(tipo.id_tipo_veiculo)) || {};
          const faixas = {};
          COLUNAS_FAIXAS.forEach((col) => {
            const v = salvo.faixas_mao_obra && salvo.faixas_mao_obra[col] !== undefined
              ? salvo.faixas_mao_obra[col]
              : (tipo.faixas_mao_obra || {})[col];
            faixas[col] = v == null ? null : v;
          });
          const linhas = {};
          (tipo.linhas || []).forEach((linha) => {
            const l = (salvo.linhas || []).find((x) => x.cod_tarifa === linha.cod_tarifa);
            linhas[linha.cod_tarifa] = l ? l.valor : linha.valor;
          });
          valores[tipo.id_tipo_veiculo] = { faixas_mao_obra: faixas, linhas };
        });
        this.valores = valores;
        this.envio = envio;
        this.dialog = true;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    fechar() {
      this.dialog = false;
      this.envio = null;
    },
    payloadValores() {
      return {
        tipos_veiculo: this.tipos.map((tipo) => ({
          id_tipo_veiculo: tipo.id_tipo_veiculo,
          faixas_mao_obra: this.valores[tipo.id_tipo_veiculo].faixas_mao_obra,
          linhas: (tipo.linhas || []).map((linha) => ({
            cod_tarifa: linha.cod_tarifa,
            valor: this.valores[tipo.id_tipo_veiculo].linhas[linha.cod_tarifa],
          })),
        })),
      };
    },
    async salvar(finalizar) {
      this.salvando = true;
      try {
        await apiController.request(apiController.endpoints.subsidioSalvarvaloresenviotemplatecontrato, {
          data: { id_envio: this.envio.id_envio, valores: this.payloadValores() },
          silent: true,
        });
        if (finalizar) {
          await apiController.request(apiController.endpoints.subsidioFinalizarenviotemplatecontrato, {
            data: { id_envio: this.envio.id_envio },
            silent: true,
          });
        }
        EventBus.$emit('show-alert', {
          mensagem: this.$t(finalizar ? 'receivedTemplate.finished' : 'receivedTemplate.draftSaved'),
          tipo: 'success',
        });
        this.fechar();
        this.carrega();
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
